import Toastr from "../../../itrust_common/components/Toastr";

const DEFAULT_STATE = {
  activeDashboard: 'appointments',
  activeDuration: 'yearly',
  graphs: null,
  saving: false,
  meta: { pagination: {} },
}

let changes = null;
export default function analyticsReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {

    case 'ORGANISATION_DASHBOARD_LOAD_PENDING':
      changes = { saving: true }
      return { ...state, ...changes };

    case 'ANALYTICS_ACTIVE_DASHBOARD':
      changes = {
        ...state, ...action.payload
      };
      return { ...state, ...changes };

    case 'ORGANISATION_DASHBOARD_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false
      }
      return { ...state, ...changes };

    case 'ORGANISATION_DASHBOARD_LOAD_FULFILLED':
      changes = {
        graphs: response,
        meta: response.meta,
        saving: false
      }
      return { ...state, ...changes };

    case 'ANALYTICS_RESET':
      changes = {
        ...DEFAULT_STATE
      }
      return { ...state, ...changes };

    default:
      return state;
  }
}